// core version + navigation, pagination modules:
import { $qs, $qsa } from "./utils/querySelector";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import tailwindConfig from "../../tailwind.config";
import { lenis } from "./misc.js";

gsap.registerPlugin(ScrollTrigger);

function news() {
	const newsHeader = $qs('[data-name="news-header"]');

	if (!newsHeader) return;

	const screenSM = tailwindConfig.theme.screens.sm.replace("px", "");
	const screenMD = tailwindConfig.theme.screens.md.replace("px", "");
	const screenXL = tailwindConfig.theme.screens.xl.replace("px", "");

	const newsGrid = $qs('[data-name="news-grid"]');
	const newsFilter = $qs('[data-name="news-filter"]');
	const topFilter = $qs('[data-name="news-top-filter"]');
	const gridItems = $qsa(".search-filter-results > * > a");

	if (window.innerWidth >= screenSM) {
		const itemHeight = gridItems[0].offsetHeight;
		const gapHeight = 20; // Gap between items
		let downTransformItems, upTransformItems, fadeOutStartIndex;

		if (window.innerWidth >= screenXL) {
			upTransformItems = [0, 2, 3, 5];
			downTransformItems = [1, 4];
			fadeOutStartIndex = 6;
		} else {
			upTransformItems = [0, 2];
			downTransformItems = [1, 3];
			fadeOutStartIndex = 4;
		}

		if (gridItems.length > fadeOutStartIndex) {
			gsap.set(Array.from(gridItems).slice(fadeOutStartIndex), { opacity: 0 });
		}

		const gridPadding =
			parseInt(window.getComputedStyle(newsGrid).paddingTop) || 0;

		upTransformItems.forEach((index) => {
			if (gridItems[index]) {
				gsap.set(gridItems[index], {
					y: -(itemHeight * 2 + gapHeight * 2 + gridPadding), // Consider two gaps and padding
				});
			}
		});

		downTransformItems.forEach((index) => {
			if (gridItems[index]) {
				gsap.set(gridItems[index], {
					y: window.innerHeight - gridPadding,
				});
			}
		});

		gsap.set(newsGrid, { opacity: 1 });

		// Create a timeline for the initial animations
		let tl = gsap.timeline({ delay: 0.5 });

		// Add the header animation to the timeline
		tl.to(newsHeader, { opacity: 1 });

		// Add the grid item animations to the timeline
		tl.to(
			upTransformItems.map((index) => gridItems[index]),
			{
				y: "+=" + window.innerHeight / 3 + "px", // Move down by 100px
				duration: 1,
				ease: "power2.out",
			},
			"-=0.5"
		); // Slight overlap with the header animation

		tl.to(
			downTransformItems.map((index) => gridItems[index]),
			{
				y: "-=" + window.innerHeight / 3 + "px", // Move up by 100px (which is down relative to their initial position)
				duration: 1,
				ease: "power2.out",
			},
			"<"
		); // Start at the same time as the previous animation

		// Create a new timeline for the scroll-triggered animation
		let scrollTl = gsap.timeline({
			scrollTrigger: {
				trigger: newsHeader,
				start: "+2px top",
				end: "+=100%", // Add an end point for the scroll trigger
				onEnter: () => {
					scrollTl.play();
				},
				onEnterBack: () => {
					// Reverse the timeline when scrolling back to top
					scrollTl.reverse();
				},
				// pin: newsHeader, // Pin the newsHeader
				pinSpacing: false,
				// markers: true,
			},
		});

		// Add event listeners to pause and resume Lenis scrolling
		scrollTl.eventCallback("onStart", () => {
			if (lenis) lenis.stop();
		});

		scrollTl.eventCallback("onComplete", () => {
			if (lenis) lenis.start();
			// Fade in remaining grid items without stagger
			gsap.to(gridItems, {
				opacity: 1,
				duration: 0.5,
				ease: "power2.out",
			});
		});

		scrollTl.eventCallback("onReverseComplete", () => {
			if (lenis) lenis.start();
		});

		// Fade out newsHeader
		scrollTl.to(
			newsHeader,
			{
				opacity: 0,
				duration: 0.8,
				ease: "power2.out",
			},
			0
		);
		scrollTl.to(
			topFilter,
			{
				autoAlpha: 0,
				duration: 0.8,
				ease: "power2.out",
			},
			0
		);
		// Add animations to return items to their original positions
		scrollTl.to(
			upTransformItems.map((index) => gridItems[index]),
			{
				y: 0,
				duration: 1,
				ease: "power2.out",
			},
			0
		);

		scrollTl.to(
			downTransformItems.map((index) => gridItems[index]),
			{
				y: 0,
				duration: 1,
				ease: "power2.out",
			},
			0
		);

		scrollTl.to(
			newsFilter,
			{
				opacity: 1,
				duration: 0.4,
				ease: "power2.out",
			},
			0.6
		);

		// Pause the timeline initially
		scrollTl.pause();
	} else {
		// For small screens, just fade in the news header
		gsap.to(newsHeader, {
			opacity: 1,
			duration: 1,
			ease: "power2.out",
		});
		gsap.to(newsGrid, {
			opacity: 1,
			duration: 1,
			ease: "power2.out",
		});
	}
}

export default news;
